import React from 'react';
import HomePage from './Home';

const Home = props => <HomePage {...props} />;

export default Home;
